<template>  
  <div>
    <v-layout>
      <v-flex md8 class="px-4">
        <h3>Años fiscales</h3>
			</v-flex>
      <v-flex md4 class="px-4">
        <template v-if="myPermissions.includes(12)">
          <v-btn color="primary" @click="redirec" class="float-r">Gestionar Años Fiscales</v-btn>
        </template>
			</v-flex>
    </v-layout>
    <br>
		<v-data-table
			hide-default-footer
			:headers="headers"
			:items="filtered_items"
			class="tablaT1"
			 :class="dark_t?'dark':''">
			<template v-slot:item="props">
				<tr>
					<fs1 tag='td'>{{props.item.year}}</fs1>
					<fs1 tag='td'>{{props.item.current ? 'Sí':'No'}}</fs1>
					<fs1 tag='td'>{{props.item.due_date}}</fs1>
					<fs1 tag='td' :prop="st = due_date_status(props.item)">
						<span :class="['safety-tag', due_date_status_color[st]]">{{st}}</span>
					</fs1>
				</tr>
			</template>
		</v-data-table>

  </div>	
</template>

<script>
import due_date_status from '@/components/mixins/due_date_status';

export default {
  mixins: [due_date_status],
  computed: {
		filtered_items(){ return this.items.filter(f => f.current)},
		items (){ return this.$store.getters.fiscal_years },
    headers() {
      return [
				{ text: 'Año', sortable: true, value: 'year' },
				{ text: 'Vigente', sortable: true, value: 'current' },
				{ text: 'Fecha de vencimiento', sortable: true, value: 'due_date' },
				{ text: 'Estado', sortable: true, value: 'due_date' },
      ];
    },
  },
  methods: {
		redirec(){this.$router.push({ name: 'admin/fiscal_years'})}
  },
};
</script>
